import { useEffect, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resetWindowScroll } from '@/lib/resetWindowScroll';

/** Reset scroll on navigation — avoids mobile landing mid-page or near the footer. */
export function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
  }, []);

  useLayoutEffect(() => {
    if (hash) return;
    resetWindowScroll();
  }, [pathname, search, hash]);

  return null;
}
